module.exports = __webpack_public_path__ + "static/media/img_trade_reno.6b1a1cc0.jpg";